import { render, staticRenderFns } from "./ReadAgreementPage.vue?vue&type=template&id=2d0d3710&"
import script from "./ReadAgreementPage.js?vue&type=script&lang=js&"
export * from "./ReadAgreementPage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports